import { render, staticRenderFns } from "./UnternehmenItem.vue?vue&type=template&id=fb04f146&scoped=true&"
import script from "./UnternehmenItem.vue?vue&type=script&lang=ts&"
export * from "./UnternehmenItem.vue?vue&type=script&lang=ts&"
import style0 from "./UnternehmenItem.vue?vue&type=style&index=0&id=fb04f146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb04f146",
  null
  
)

export default component.exports